import PayPalCheckoutForm from "./StripeCheckoutForm";
import React, { useState, useEffect } from "react";
import "./App.css";
import { useSelector } from "react-redux";

export default function PayPalPay({ formData, paymentMethod = 'paypal', amount, remainingAmount }) {
  const { userInfo } = useSelector((state) => state.auth);
  const [isReady, setIsReady] = useState(false);
  const [error] = useState("");
  const { addresses } = useSelector((state) => state.address);
  let formLength = Object.values(formData || {}).filter(
    (item) => item !== ""
  ).length;

  useEffect(() => {
    // Check if form is ready for payment
    if (userInfo) {
      // For logged in users, check if they have addresses
      if (addresses && addresses.length > 0) {
        // Small delay to ensure everything is loaded
        setTimeout(() => {
          setIsReady(true);
        }, 300);
      }
    } else {
      // For guest users, check if form is filled
      if (formLength > 6) {
        setTimeout(() => {
          setIsReady(true);
        }, 300);
      }
    }
  }, [addresses, formLength, userInfo]);

  return (
    <div className="App">
      {isReady ? (
        <PayPalCheckoutForm paymentMethod={paymentMethod} amount={amount} remainingAmount={remainingAmount} />
      ) : (
        <div className="text-center py-4">
          {userInfo ? (
            <>
              {error ? (
                <p className="text-red-600">{error}</p>
              ) : addresses && addresses.length === 0 ? (
                <p className="text-amber-600 font-medium">
                  Please add a delivery address to continue with payment
                </p>
              ) : (
                <p className="text-dark-grayish-blue">Loading payment options...</p>
              )}
            </>
          ) : (
            <p className="text-dark-grayish-blue">
              Fill the form above to proceed with payment
            </p>
          )}
        </div>
      )}
    </div>
  );
}
